import { FC } from 'react';
import { IFormProps } from '.';
import PlaceholderViewModel from '../Models/PlaceholderViewModel';

interface IPlaceholderProps extends IFormProps {
	model: PlaceholderViewModel;
}

const Placeholder: FC<IPlaceholderProps> = ({ model }) => {
	return (
		<h3 hidden={!model.ControlVisibility}>
			{`${model.Caption} ( Тип - ${model.DescriptorKey})`}
		</h3>
	);
};

export default Placeholder;
